const labels = [
    { id: 30, color: "#b8255f" },
    { id: 31, color: "#db4035" },
    { id: 32, color: "#ff9933" },
    { id: 33, color: "#fad000" },
    { id: 34, color: "#afb83b" },
    { id: 35, color: "#7ecc49" },
    { id: 36, color: "#299438" },
    { id: 37, color: "#6accbc" },
    { id: 38, color: "#158fad" },
    { id: 39, color: "#14aaf5" },
    { id: 40, color: "#96c3eb" },
    { id: 41, color: "#4073ff" },
    { id: 42, color: "#884dff" },
    { id: 43, color: "#af38eb" },
    { id: 44, color: "#eb96eb" },
    { id: 45, color: "#e05194" },
    { id: 46, color: "#ff8d85" },
    { id: 47, color: "#808080" },
    { id: 48, color: "#b8b8b8" },
    { id: 49, color: "#ccac93" }
];

const priorities = [
    { id: 1, color: "#eeeeee" },
    { id: 2, color: "#5297ff" },
    { id: 3, color: "#ff9a14" },
    { id: 4, color: "#ff7066" }
];

export {
    labels,
    priorities
}